import { useContext, useEffect } from "react";

import MapContext from "../map/MapContext";

import olMap from "ol/Map";
import olVectorSource from "ol/source/Vector";
import Modify from "ol/interaction/Modify";
import Interaction from "ol/interaction/Interaction";
import { OLParser } from "../JSTS/OL";

export interface PolygonProps {
  source: olVectorSource;
  active: boolean;
  onDrawEnd?: (polygon: jsts.geom.Polygon) => void;
}
let modify: Interaction;
export const EditPolygon = ({
  source,
  active,
  onDrawEnd: onDrawEnd,
}: PolygonProps) => {
  const map = useContext(MapContext) as olMap;
  useEffect(() => {
    if (!map || !active) return () => {};

    const modify = new Modify({
      source: source,
    });

    map.addInteraction(modify);

    modify.on("modifyend", (e) => {
      if (!onDrawEnd) return;
      const jstsGeom = OLParser.read(
        e.features.getArray()[0].getGeometry()
      ) as jsts.geom.Polygon;
      onDrawEnd(jstsGeom);
    });
    return () => {
      if (!map) return;
      map.removeInteraction(modify);
    };
  }, [map, source, onDrawEnd]);

  useEffect(() => {
    if (modify === null || modify === undefined || map === null) return;
    if (active == false) {
      map.removeInteraction(modify);
    } else {
      map.addInteraction(modify);
    }
  }, [active]);

  return null;
};
